import styled from "styled-components";

export const CheckTransportationDeleteModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;

  p {
    font-size: 1.4rem;
    font-weight: 600;
    span {
      color: ${(props) => props.theme.colors.red};
    }
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .small {
    width: 50%;
  }
`;
